import { render, staticRenderFns } from "./GenericSidebar.vue?vue&type=template&id=28e146eb"
import script from "./GenericSidebar.vue?vue&type=script&lang=js"
export * from "./GenericSidebar.vue?vue&type=script&lang=js"
import style0 from "./GenericSidebar.vue?vue&type=style&index=0&id=28e146eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports